import { type ReactNode, useEffect } from 'react';
import { useAppStore } from '../../contexts/store';
import { PermissionProvider } from '../../contexts/PermissionContext';
import { LimitProvider, useLimitContext } from '../../contexts/LimitContext';
import { setLimitErrorHandler } from '../../contexts/limitHandler';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Component that connects the limit context to the API client
 */
function LimitErrorConnector({ children }: { children: ReactNode }) {
  const { showLimitError } = useLimitContext();

  useEffect(() => {
    // Register the handler so the API client can trigger the modal
    setLimitErrorHandler(showLimitError);
  }, [showLimitError]);

  return <>{children}</>;
}

/**
 * Wraps the app with all necessary providers including permissions.
 * The PermissionProvider reads the user from the Zustand store.
 */
export function AppProviders({ children }: AppProvidersProps) {
  const user = useAppStore((state) => state.user);

  return (
    <LimitProvider>
      <LimitErrorConnector>
        <PermissionProvider user={user}>
          {children}
        </PermissionProvider>
      </LimitErrorConnector>
    </LimitProvider>
  );
}
